import React from 'react';
import { coverageAreas } from '../data/content';
import useReveal from '../hooks/useReveal';
import './Coverage.css';

function AreaCard({ region, icon, colour, places }) {
  const ref = useReveal();
  return (
    <div className={`area-card area-card--${colour}`} ref={ref}>
      <div className="area-card__header">
        <span className="area-card__icon">{icon}</span>
        <h3 className="area-card__region">{region}</h3>
      </div>
      <ul className="area-card__places">
        {places.map((place) => (
          <li key={place} className="area-card__place">
            <span className="area-card__dot" aria-hidden="true" />
            {place}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Coverage() {
  const headerRef = useReveal();

  return (
    <section className="coverage" id="coverage">
      <div className="coverage__header" ref={headerRef}>
        <span className="section-label">Where We Work</span>
        <h2 className="section-title">
          Proudly Serving the <em>North West</em>
        </h2>
        <p className="coverage__sub">
          Based in Wavertree, Liverpool, we proudly serve customers across Merseyside and 
          the wider North West, including the Wirral, Manchester and Cheshire. Not sure if 
          we cover your area? Just give us a call.
        </p>
      </div>

      {/* <div className="coverage__grid">
        {coverageAreas.map((area) => (
          <AreaCard key={area.region} {...area} />
        ))}
      </div> */}

      <div className="coverage__footer" ref={useReveal()}>
        <div className="coverage__note">
          <span className="coverage__note-icon">📍</span>
          <p><strong>Based at:</strong> Unit 1G Wavertree Boulevard South, Liverpool, L7 9PF <br /></p>
          <p>&nbsp;·&nbsp; Travelling to all surrounding areas at no extra charge within our coverage zones.</p>
        </div>
        <a href="#contact" className="btn btn--primary">Check Your Area</a>
      </div>
    </section>
  );
}
